export const LEVELS = {
  NONE: 0,
  READ: 10,
  WRITE: 20,
  DELETE: 30,
  ADMIN: 40,
};

export const MODULES = {
  // Raw Item Masters
  MOD_BRAND: "MOD_BRAND",
  MOD_SUBBRAND: "MOD_SUBBRAND",
  MOD_RAW_ITEM: "MOD_RAW_ITEM",
  MOD_SIZE: "MOD_SIZE",
  MOD_SHAPE: "MOD_SHAPE",
  MOD_COLOR: "MOD_COLOR",
  MOD_SIZE_GROUP: "MOD_SIZE_GROUP",
  MOD_UNIT: "MOD_UNIT",
  MOD_UOM_CONV: "MOD_UOM_CONV",
  MOD_CNDN_TYPES: "MOD_CNDN_TYPES",
  MOD_AREA: "MOD_AREA",

  // Main Item Masters
  MOD_ITEM_BULK: "MOD_ITEM_BULK",
  MOD_PACK_RATIO: "MOD_PACK_RATIO",
  MOD_PRICELIST: "MOD_PRICELIST",
  MOD_ORDER_PRINT_GROUP: "MOD_ORDER_PRINT_GROUP",
  MOD_DISCOUNT: "MOD_DISCOUNT",

  // Account Masters
  MOD_PARTY_GROUP: "MOD_PARTY_GROUP",
  MOD_GL_ACCOUNTS: "MOD_GL_ACCOUNTS",
  MOD_OPN_BAL: "MOD_OPN_BAL",
  MOD_PROFILING: "MOD_PROFILING",

  // Inventory
  MOD_ORDER: "MOD_ORDER",
  MOD_ORDER_RECON: "MOD_ORDER_RECON",
  MOD_SHIPPING: "MOD_SHIPPING",
  MOD_SALEBILL: "MOD_SALEBILL",
  MOD_CNDN: "MOD_CNDN",

  // Accounts
  MOD_VOUCHER: "MOD_VOUCHER",
  MOD_MONEY_RECEIPT: "MOD_MONEY_RECEIPT",
  MOD_JOURNAL: "MOD_JOURNAL",
  MOD_CV_LETTER: "MOD_CV_LETTER",
  MOD_PAYMENT_RECON: "MOD_PAYMENT_RECON",
  MOD_DUE_REMINDER: "MOD_DUE_REMINDER",

  // Reports - Inventory
  MOD_REP_INV_ITEM_LIST: "MOD_REP_INV_ITEM_LIST",
  MOD_REP_INV_ORDER_HIST: "MOD_REP_INV_ORDER_HIST",
  MOD_REP_INV_ORDER_REG: "MOD_REP_INV_ORDER_REG",
  MOD_REP_INV_PEND_ORDER: "MOD_REP_INV_PEND_ORDER",
  MOD_REP_INV_BILL_REG: "MOD_REP_INV_BILL_REG",
  MOD_REP_INV_DN_REG: "MOD_REP_INV_DN_REG",
  MOD_REP_INV_CN_REG: "MOD_REP_INV_CN_REG",

  // Reports - Accounts
  MOD_REP_ACC_OPN_TRAIL: "MOD_REP_ACC_OPN_TRAIL",
  MOD_REP_ACC_JRNL: "MOD_REP_ACC_JRNL",
  MOD_REP_ACC_LEDGER: "MOD_REP_ACC_LEDGER",
  MOD_REP_ACC_TRAIL_BAL: "MOD_REP_ACC_TRAIL_BAL",
  MOD_REP_ACC_BAL_SHEET: "MOD_REP_ACC_BAL_SHEET",
  MOD_REP_ACC_PROFIT_LOSS: "MOD_REP_ACC_PROFIT_LOSS",
  MOD_REP_ACC_DAY_BOOK: "MOD_REP_ACC_DAY_BOOK",
  MOD_REP_ACC_AGING: "MOD_REP_ACC_AGING",
  MOD_REP_ACC_ANALYSIS: "MOD_REP_ACC_ANALYSIS",
  MOD_REP_SALES: "MOD_REP_SALES",

  // Scheme
  MOD_SCH_GIFT: "MOD_SCH_GIFT",
  MOD_SCH_MASTER: "MOD_SCH_MASTER",
  MOD_SCH_DETAIL: "MOD_SCH_DETAIL",
  MOD_SCH_ISSUE: "MOD_SCH_ISSUE",
  MOD_SCH_ORDER_RECON: "MOD_SCH_ORDER_RECON",
  MOD_REP_SCH_PRINT: "MOD_REP_SCH_PRINT",
  MOD_REP_SCH_ELIG_SUM: "MOD_REP_SCH_ELIG_SUM",
  MOD_REP_SCH_ELIG_DTL: "MOD_REP_SCH_ELIG_DTL",
  MOD_REP_SCH_PEND: "MOD_REP_SCH_PEND",

  // Plus / Misc
  MOD_DOC_VIEWER: "MOD_DOC_VIEWER",
  MOD_MAIL_TRACKER: "MOD_MAIL_TRACKER",

};
